module.exports = __webpack_public_path__ + "images/b3fde3c5f58b20f0d4bba6d02944f407-logo_beta.png";